export interface Session {
  id: string;
  date: string;
  time: string;
  seller: string;
}

export interface LoyaltyCard {
  id: string;
  cardNumber: number;
  customerId: string;
  startDate: string;
  endDate: string | null;
  sessions: Session[];
  reward25Earned: boolean;
  reward25RedeemedAt: string | null;
  reward50Earned: boolean;
  reward50RedeemedAt: string | null;
  isActive: boolean;
  salonName?: string;
}

export interface Customer {
  id: string;
  name: string;
  email: string;
  joinedAt: string;
  loyaltyCards: LoyaltyCard[];
}

export interface Seller {
  id: string;
  name: string;
  email: string;
  password: string;
  role: 'owner' | 'staff';
}

export const MOCK_SELLERS: Seller[] = [
  { id: 'seller-001', name: 'Veronika Šťastná', email: 'stastna.veronika07@gmail.com', password: 'VQstudio2025!', role: 'owner' },
  { id: 'seller-002', name: 'Mia Tran', email: 'mia@vqstudio.com', password: 'VQstudio2025!', role: 'staff' },
  { id: 'seller-003', name: 'Sophie Lee', email: 'sophie@vqstudio.com', password: 'VQstudio2025!', role: 'staff' },
];

export const MOCK_CUSTOMERS: Customer[] = [
  {
    id: 'cust-001',
    name: 'Amélie Fontaine',
    email: 'amelie@example.com',
    joinedAt: '2025-03-10',
    loyaltyCards: [
      {
        id: 'card-001-1',
        cardNumber: 1,
        customerId: 'cust-001',
        startDate: '2025-03-10',
        endDate: '2025-07-22',
        sessions: [
          { id: 'sess-001', date: '2025-03-10', time: '10:30', seller: 'Vivian Q.' },
          { id: 'sess-002', date: '2025-03-28', time: '14:00', seller: 'Mia Tran' },
          { id: 'sess-003', date: '2025-04-15', time: '11:00', seller: 'Vivian Q.' },
          { id: 'sess-004', date: '2025-05-02', time: '15:30', seller: 'Sophie Lee' },
          { id: 'sess-005', date: '2025-05-20', time: '10:00', seller: 'Vivian Q.' },
          { id: 'sess-006', date: '2025-06-05', time: '13:00', seller: 'Mia Tran' },
          { id: 'sess-007', date: '2025-06-20', time: '16:00', seller: 'Vivian Q.' },
          { id: 'sess-008', date: '2025-07-03', time: '11:30', seller: 'Sophie Lee' },
          { id: 'sess-009', date: '2025-07-15', time: '14:30', seller: 'Vivian Q.' },
          { id: 'sess-010', date: '2025-07-22', time: '10:00', seller: 'Mia Tran' },
        ],
        reward25Earned: true,
        reward25RedeemedAt: '2025-05-20',
        reward50Earned: true,
        reward50RedeemedAt: '2025-07-22',
        isActive: false,
      },
      {
        id: 'card-001-2',
        cardNumber: 2,
        customerId: 'cust-001',
        startDate: '2025-07-23',
        endDate: null,
        sessions: [
          { id: 'sess-011', date: '2025-07-30', time: '10:00', seller: 'Vivian Q.' },
          { id: 'sess-012', date: '2025-08-08', time: '14:00', seller: 'Mia Tran' },
          { id: 'sess-013', date: '2025-08-15', time: '11:30', seller: 'Vivian Q.' },
          { id: 'sess-014', date: '2025-08-20', time: '15:00', seller: 'Sophie Lee' },
          { id: 'sess-015', date: '2025-08-23', time: '09:30', seller: 'Vivian Q.' },
        ],
        reward25Earned: true,
        reward25RedeemedAt: null,
        reward50Earned: false,
        reward50RedeemedAt: null,
        isActive: true,
      },
    ],
  },
  {
    id: 'cust-002',
    name: 'Hana Yoshida',
    email: 'hana@example.com',
    joinedAt: '2025-05-01',
    loyaltyCards: [
      {
        id: 'card-002-1',
        cardNumber: 1,
        customerId: 'cust-002',
        startDate: '2025-05-01',
        endDate: '2025-08-10',
        sessions: [
          { id: 'sess-021', date: '2025-05-01', time: '11:00', seller: 'Vivian Q.' },
          { id: 'sess-022', date: '2025-05-18', time: '13:00', seller: 'Mia Tran' },
          { id: 'sess-023', date: '2025-06-02', time: '15:00', seller: 'Vivian Q.' },
          { id: 'sess-024', date: '2025-06-20', time: '10:30', seller: 'Sophie Lee' },
          { id: 'sess-025', date: '2025-07-05', time: '14:00', seller: 'Vivian Q.' },
          { id: 'sess-026', date: '2025-07-18', time: '11:00', seller: 'Mia Tran' },
          { id: 'sess-027', date: '2025-07-30', time: '16:00', seller: 'Vivian Q.' },
          { id: 'sess-028', date: '2025-08-05', time: '10:00', seller: 'Sophie Lee' },
          { id: 'sess-029', date: '2025-08-08', time: '13:30', seller: 'Vivian Q.' },
          { id: 'sess-030', date: '2025-08-10', time: '11:00', seller: 'Mia Tran' },
        ],
        reward25Earned: true,
        reward25RedeemedAt: '2025-07-05',
        reward50Earned: true,
        reward50RedeemedAt: '2025-08-10',
        isActive: false,
      },
      {
        id: 'card-002-2',
        cardNumber: 2,
        customerId: 'cust-002',
        startDate: '2025-08-11',
        endDate: null,
        sessions: [
          { id: 'sess-031', date: '2025-08-18', time: '14:00', seller: 'Vivian Q.' },
          { id: 'sess-032', date: '2025-08-23', time: '10:30', seller: 'Sophie Lee' },
        ],
        reward25Earned: false,
        reward25RedeemedAt: null,
        reward50Earned: false,
        reward50RedeemedAt: null,
        isActive: true,
      },
    ],
  },
  {
    id: 'cust-003',
    name: 'Lena Bergström',
    email: 'lena@example.com',
    joinedAt: '2025-06-15',
    loyaltyCards: [
      {
        id: 'card-003-1',
        cardNumber: 1,
        customerId: 'cust-003',
        startDate: '2025-06-15',
        endDate: null,
        sessions: [
          { id: 'sess-041', date: '2025-06-15', time: '10:00', seller: 'Mia Tran' },
          { id: 'sess-042', date: '2025-07-01', time: '14:00', seller: 'Vivian Q.' },
          { id: 'sess-043', date: '2025-07-20', time: '11:30', seller: 'Sophie Lee' },
          { id: 'sess-044', date: '2025-08-05', time: '15:00', seller: 'Vivian Q.' },
          { id: 'sess-045', date: '2025-08-15', time: '10:00', seller: 'Mia Tran' },
          { id: 'sess-046', date: '2025-08-23', time: '13:00', seller: 'Vivian Q.' },
        ],
        reward25Earned: true,
        reward25RedeemedAt: null,
        reward50Earned: false,
        reward50RedeemedAt: null,
        isActive: true,
      },
    ],
  },
  {
    id: 'cust-004',
    name: 'Priya Sharma',
    email: 'priya@example.com',
    joinedAt: '2025-07-10',
    loyaltyCards: [
      {
        id: 'card-004-1',
        cardNumber: 1,
        customerId: 'cust-004',
        startDate: '2025-07-10',
        endDate: null,
        sessions: [
          { id: 'sess-051', date: '2025-07-10', time: '11:00', seller: 'Vivian Q.' },
          { id: 'sess-052', date: '2025-07-25', time: '14:30', seller: 'Mia Tran' },
          { id: 'sess-053', date: '2025-08-08', time: '10:00', seller: 'Vivian Q.' },
          { id: 'sess-054', date: '2025-08-20', time: '15:00', seller: 'Sophie Lee' },
        ],
        reward25Earned: false,
        reward25RedeemedAt: null,
        reward50Earned: false,
        reward50RedeemedAt: null,
        isActive: true,
      },
    ],
  },
  {
    id: 'cust-005',
    name: 'Chloe Martin',
    email: 'chloe@example.com',
    joinedAt: '2025-08-01',
    loyaltyCards: [
      {
        id: 'card-005-1',
        cardNumber: 1,
        customerId: 'cust-005',
        startDate: '2025-08-01',
        endDate: null,
        sessions: [
          { id: 'sess-061', date: '2025-08-01', time: '10:00', seller: 'Sophie Lee' },
          { id: 'sess-062', date: '2025-08-12', time: '13:00', seller: 'Vivian Q.' },
          { id: 'sess-063', date: '2025-08-23', time: '11:00', seller: 'Mia Tran' },
        ],
        reward25Earned: false,
        reward25RedeemedAt: null,
        reward50Earned: false,
        reward50RedeemedAt: null,
        isActive: true,
      },
    ],
  },
  {
    id: 'cust-006',
    name: 'Nour Al-Rashid',
    email: 'nour@example.com',
    joinedAt: '2025-04-20',
    loyaltyCards: [
      {
        id: 'card-006-1',
        cardNumber: 1,
        customerId: 'cust-006',
        startDate: '2025-04-20',
        endDate: '2025-08-01',
        sessions: Array.from({ length: 10 }, (_, i) => ({
          id: `sess-07${i + 1}`,
          date: `2025-0${4 + Math.floor(i / 3)}-${10 + i * 3 < 31 ? 10 + i * 3 : (10 + i * 3) - 30}`,
          time: '11:00',
          seller: i % 2 === 0 ? 'Vivian Q.' : 'Mia Tran',
        })),
        reward25Earned: true,
        reward25RedeemedAt: '2025-06-10',
        reward50Earned: true,
        reward50RedeemedAt: '2025-08-01',
        isActive: false,
      },
      {
        id: 'card-006-2',
        cardNumber: 2,
        customerId: 'cust-006',
        startDate: '2025-08-02',
        endDate: null,
        sessions: [
          { id: 'sess-081', date: '2025-08-10', time: '14:00', seller: 'Vivian Q.' },
          { id: 'sess-082', date: '2025-08-19', time: '10:30', seller: 'Sophie Lee' },
          { id: 'sess-083', date: '2025-08-23', time: '15:00', seller: 'Vivian Q.' },
          { id: 'sess-084', date: '2025-08-23', time: '16:00', seller: 'Mia Tran' },
          { id: 'sess-085', date: '2025-08-23', time: '17:00', seller: 'Vivian Q.' },
          { id: 'sess-086', date: '2025-08-23', time: '18:00', seller: 'Sophie Lee' },
          { id: 'sess-087', date: '2025-08-23', time: '18:30', seller: 'Vivian Q.' },
        ],
        reward25Earned: true,
        reward25RedeemedAt: null,
        reward50Earned: false,
        reward50RedeemedAt: null,
        isActive: true,
      },
    ],
  },
];

export function getActiveCard(customer: Customer): LoyaltyCard | null {
  return customer.loyaltyCards.find(c => c.isActive) || null;
}

export function getSessionCount(card: LoyaltyCard): number {
  return card.sessions.length;
}

export function getProgress(card: LoyaltyCard): { count: number; total: number; nextMilestone: number; reward: string } {
  const count = card.sessions.length;
  if (count < 5) return { count, total: 10, nextMilestone: 5, reward: '25% OFF' };
  if (count < 10) return { count, total: 10, nextMilestone: 10, reward: '50% OFF' };
  return { count: 10, total: 10, nextMilestone: 10, reward: '50% OFF' };
}

export function formatDate(dateStr: string, locale: 'en' | 'cs' = 'en'): string {
  const monthsEn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthsCs = ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'];
  const [year, month, day] = dateStr.split('-');
  const months = locale === 'cs' ? monthsCs : monthsEn;
  return `${months[parseInt(month) - 1]} ${parseInt(day)}, ${year}`;
}

export function getQRValue(customerId: string): string {
  // Encode customer ID in a scannable format
  return `vqstudio://customer/${customerId}`;
}

export function parseQRValue(qrData: string): string | null {
  const match = qrData.match(/^vqstudio:\/\/customer\/(.+)$/);
  return match ? match[1] : null;
}

// ── QR payload: self-contained customer identity ────────────────────────────

export interface QRCustomerPayload {
  n: string;  // name
  e: string;  // email
  j: string;  // joinedAt date
}

/**
 * Build a self-contained QR payload that works on ANY device.
 * The payload encodes name + email + joinedAt so the scanner
 * never needs to look up localStorage on a different device.
 */
export function buildQRPayload(customer: Customer): string {
  const payload: QRCustomerPayload = {
    n: customer.name,
    e: customer.email.trim().toLowerCase(),
    j: customer.joinedAt,
  };
  return `LYL:${JSON.stringify(payload)}`;
}

/**
 * Parse a QR string. Returns the payload object or null if not a Loyalo QR.
 * Also handles legacy formats for backward compatibility.
 */
export function parseQRString(qrData: string): QRCustomerPayload | null {
  const trimmed = qrData.trim();

  // New format: LYL:{...json...}
  if (trimmed.startsWith('LYL:')) {
    try {
      const json = trimmed.slice(4);
      const parsed = JSON.parse(json) as QRCustomerPayload;
      if (parsed.e && parsed.n) return parsed;
    } catch { /* fall through */ }
  }

  // Legacy format: loyalo:email
  if (trimmed.startsWith('loyalo:')) {
    const email = trimmed.slice(7).trim();
    if (email) return { n: '', e: email, j: '' };
  }

  // Legacy format: vqstudio://customer/id — can't recover name/email from this
  return null;
}

/**
 * Resolve a scanned QR payload to a Customer object.
 * 1. If customer exists in localStorage (same device), use that data.
 * 2. Otherwise build a fresh Customer from the QR payload itself.
 * This works across ALL devices — no shared storage needed.
 */
export function resolveCustomerFromQR(payload: QRCustomerPayload): Customer {
  const email = payload.e.trim().toLowerCase();

  // Check mock customers first
  const mock = MOCK_CUSTOMERS.find(c => c.email.toLowerCase() === email);
  if (mock) return mock;

  if (typeof window !== 'undefined') {
    // Check localStorage for existing loyalty data
    const loyaltyRaw = localStorage.getItem(`vq_loyalty_${email}`);
    if (loyaltyRaw) {
      try {
        const existing = JSON.parse(loyaltyRaw) as Customer;
        if (existing && existing.id) return existing;
      } catch { /* fall through */ }
    }

    // Also scan all vq_loyalty_* keys
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('vq_loyalty_')) {
        try {
          const raw = localStorage.getItem(key);
          if (raw) {
            const c = JSON.parse(raw) as Customer;
            if (c.email && c.email.toLowerCase() === email) return c;
          }
        } catch { /* skip */ }
      }
    }
  }

  // Build fresh customer from QR data — works on any device
  const safeId = email.replace(/[^a-z0-9]/gi, '');
  const today = new Date().toISOString().split('T')[0];
  const joinedAt = payload.j || today;
  const newCustomer: Customer = {
    id: `cust-${safeId}`,
    name: payload.n || email,
    email: payload.e,
    joinedAt,
    loyaltyCards: [
      {
        id: `card-${safeId}-1`,
        cardNumber: 1,
        customerId: `cust-${safeId}`,
        startDate: joinedAt,
        endDate: null,
        sessions: [],
        reward25Earned: false,
        reward25RedeemedAt: null,
        reward50Earned: false,
        reward50RedeemedAt: null,
        isActive: true,
      },
    ],
  };

  // Persist so subsequent scans on this device are instant
  if (typeof window !== 'undefined') {
    localStorage.setItem(`vq_loyalty_${email}`, JSON.stringify(newCustomer));
  }

  return newCustomer;
}

// Keep legacy helpers for backward compat
export function getQRPayload(email: string): string {
  return `loyalo:${email.trim().toLowerCase()}`;
}

export function parseQRPayload(qrData: string): string | null {
  const trimmed = qrData.trim();
  if (trimmed.startsWith('loyalo:')) {
    const email = trimmed.slice('loyalo:'.length).trim();
    return email.length > 0 ? email : null;
  }
  return null;
}

/** Find a customer by email — checks mock data then localStorage */
export function findCustomerByEmail(email: string): Customer | null {
  if (!email) return null;
  const normalised = email.trim().toLowerCase();

  const mock = MOCK_CUSTOMERS.find(c => c.email.toLowerCase() === normalised);
  if (mock) return mock;

  if (typeof window === 'undefined') return null;

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('vq_loyalty_')) {
      try {
        const raw = localStorage.getItem(key);
        if (raw) {
          const customer = JSON.parse(raw) as Customer;
          if (customer.email && customer.email.toLowerCase() === normalised) return customer;
        }
      } catch { /* skip */ }
    }
  }

  try {
    const regRaw = localStorage.getItem('vq_registered_customers');
    if (regRaw) {
      const registered: Array<{ name: string; email: string; password: string; confirmed: boolean }> = JSON.parse(regRaw);
      const reg = registered.find(r => r.email.toLowerCase() === normalised);
      if (reg) {
        const loyaltyRaw = localStorage.getItem(`vq_loyalty_${reg.email}`);
        if (loyaltyRaw) {
          try { return JSON.parse(loyaltyRaw) as Customer; } catch { /* fall through */ }
        }
        const today = new Date().toISOString().split('T')[0];
        const safeId = reg.email.replace(/[^a-z0-9]/gi, '');
        const newCustomer: Customer = {
          id: `cust-${safeId}`,
          name: reg.name,
          email: reg.email,
          joinedAt: today,
          loyaltyCards: [
            {
              id: `card-${safeId}-1`,
              cardNumber: 1,
              customerId: `cust-${safeId}`,
              startDate: today,
              endDate: null,
              sessions: [],
              reward25Earned: false,
              reward25RedeemedAt: null,
              reward50Earned: false,
              reward50RedeemedAt: null,
              isActive: true,
            },
          ],
        };
        localStorage.setItem(`vq_loyalty_${reg.email}`, JSON.stringify(newCustomer));
        return newCustomer;
      }
    }
  } catch { /* skip */ }

  return null;
}
// ── END QR helpers ──────────────────────────────────────────────────────────

export function findCustomerById(customerId: string): Customer | null {
  return MOCK_CUSTOMERS.find(c => c.id === customerId) || null;
}

export function findCustomerByIdAnywhere(customerId: string): Customer | null {
  // First check mock customers
  const mock = MOCK_CUSTOMERS.find(c => c.id === customerId);
  if (mock) return mock;

  // Then search all localStorage loyalty entries for real registered customers
  if (typeof window === 'undefined') return null;
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('vq_loyalty_')) {
      try {
        const raw = localStorage.getItem(key);
        if (raw) {
          const customer = JSON.parse(raw) as Customer;
          if (customer.id === customerId) return customer;
        }
      } catch {
        // skip malformed entries
      }
    }
  }

  // Also search vq_registered_customers — customers registered on this device
  // whose loyalty data may not yet be stored under vq_loyalty_*
  try {
    const regRaw = localStorage.getItem('vq_registered_customers');
    if (regRaw) {
      const registered: Array<{ name: string; email: string; password: string; confirmed: boolean }> = JSON.parse(regRaw);
      for (const reg of registered) {
        const safeId = reg.email.replace(/[^a-z0-9]/gi, '');
        const derivedId = `cust-${safeId}`;
        if (derivedId === customerId) {
          // Try to load their loyalty data first
          const loyaltyRaw = localStorage.getItem(`vq_loyalty_${reg.email}`);
          if (loyaltyRaw) {
            try {
              return JSON.parse(loyaltyRaw) as Customer;
            } catch { /* fall through */ }
          }
          // Build a fresh customer object from registration data
          const today = new Date().toISOString().split('T')[0];
          const newCustomer: Customer = {
            id: derivedId,
            name: reg.name,
            email: reg.email,
            joinedAt: today,
            loyaltyCards: [
              {
                id: `card-${safeId}-1`,
                cardNumber: 1,
                customerId: derivedId,
                startDate: today,
                endDate: null,
                sessions: [],
                reward25Earned: false,
                reward25RedeemedAt: null,
                reward50Earned: false,
                reward50RedeemedAt: null,
                isActive: true,
              },
            ],
          };
          // Persist so future lookups are faster
          localStorage.setItem(`vq_loyalty_${reg.email}`, JSON.stringify(newCustomer));
          return newCustomer;
        }
      }
    }
  } catch {
    // skip malformed entries
  }

  return null;
}

export function createNewLoyaltyCard(customer: Customer): LoyaltyCard {
  const today = new Date().toISOString().split('T')[0];
  const lastCard = customer.loyaltyCards[customer.loyaltyCards.length - 1];
  const newCardNumber = lastCard ? lastCard.cardNumber + 1 : 1;
  return {
    id: `card-${customer.id}-${newCardNumber}`,
    cardNumber: newCardNumber,
    customerId: customer.id,
    startDate: today,
    endDate: null,
    sessions: [],
    reward25Earned: false,
    reward25RedeemedAt: null,
    reward50Earned: false,
    reward50RedeemedAt: null,
    isActive: true,
  };
}

export const CURRENT_CUSTOMER = MOCK_CUSTOMERS[0];
export const SCANNED_CUSTOMER = MOCK_CUSTOMERS[2];

export function getLoggedInCustomerData(): Customer | null {
  if (typeof window === 'undefined') return null;
  const email = localStorage.getItem('vq_email');
  const name = localStorage.getItem('vq_name');
  if (!email || !name) return null;

  // Always use lowercase email as the key — must match what VerificationContent writes
  const emailKey = email.trim().toLowerCase();

  // Try to load saved loyalty data
  const savedRaw = localStorage.getItem(`vq_loyalty_${emailKey}`);
  if (savedRaw) {
    try {
      return JSON.parse(savedRaw) as Customer;
    } catch {
      // fall through to create new
    }
  }

  // Create a fresh customer with 0 sessions
  const today = new Date().toISOString().split('T')[0];
  const safeId = emailKey.replace(/[^a-z0-9]/gi, '');
  const newCustomer: Customer = {
    id: `cust-${safeId}`,
    name,
    email: emailKey,
    joinedAt: today,
    loyaltyCards: [
      {
        id: `card-${safeId}-1`,
        cardNumber: 1,
        customerId: `cust-${safeId}`,
        startDate: today,
        endDate: null,
        sessions: [],
        reward25Earned: false,
        reward25RedeemedAt: null,
        reward50Earned: false,
        reward50RedeemedAt: null,
        isActive: true,
      },
    ],
  };
  localStorage.setItem(`vq_loyalty_${emailKey}`, JSON.stringify(newCustomer));
  return newCustomer;
}

export function saveLoggedInCustomerData(customer: Customer): void {
  if (typeof window === 'undefined') return;
  const emailKey = customer.email.trim().toLowerCase();
  localStorage.setItem(`vq_loyalty_${emailKey}`, JSON.stringify(customer));
}